import { render, staticRenderFns } from "./OpenAnswerBoxOption.vue?vue&type=template&id=c375e5fc&scoped=true"
import script from "./OpenAnswerBoxOption.vue?vue&type=script&lang=js"
export * from "./OpenAnswerBoxOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c375e5fc",
  null
  
)

export default component.exports